import { storeResetFns } from "@/app/state"

export const resetAllStores = () => {
  storeResetFns.forEach((resetFn) => resetFn())
}
